import { GetAllNewMeasureDTO, GetAllNewMeasuresFiltersDTO, NewMeasureCreationDTO, NewMeasureDTO, NewMeasureUpdateDTO, PreviousNonComplianceCodesDTO } from "./dto";
import { NewMeasureServiceImpl } from "./serviceImpl";

export interface NewMeasureService {
    CreateNewMeasure(data: NewMeasureCreationDTO): Promise<string>
    UpdateNewMeasure(data: NewMeasureUpdateDTO, id: string): Promise<void>
    DeleteNewMeasure(id: string): Promise<void>
    GetNewMeasureById(id: string): Promise<NewMeasureDTO>
    GetAllNewMeasures(filters: GetAllNewMeasuresFiltersDTO): Promise<GetAllNewMeasureDTO>
    GetCustomerPreviousNoncomplianceCodesByCustomerId(customerId: string, newMeasureId: string): Promise<PreviousNonComplianceCodesDTO>
}

export function NewNewMeasureService(): NewMeasureService {
    return new NewMeasureServiceImpl()
}